import { type GetAppRoleQuery } from '@user-management/graphql';

export default function mapAppRoleData(data?: GetAppRoleQuery['suGetAppRole']) {
  return {
    id: data?.id ?? '',
    name: data?.name ?? '',
    description: data?.description ?? '',
  };
}
